import React, { useEffect, useState } from 'react'; 
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { validate_access } from '../../apiservices/ApiService';

const AccessManager = ({ Component }) => {

  const navigate = useNavigate();
  const [data, setData] = useState({});
  // get current route
  const currentRoute = useLocation();

  useEffect(() => {
    // check the access leave for the user
    async function checkAccess() {
        
        const res = await validate_access();
        if(res.code === 200){
            if(!res?.data?.stage){
                navigate('/application');
                return; 
            }

            switch(res?.data?.stage){ 
                case "application": 
                    navigate('/application');
                    return; 
                case "upload": 
                    if(currentRoute.pathname === '/application'){
                        setData({step: 3});
                    }else { 
                        // navigate with second step
                        navigate('/application', { state: { step: 3 } });
                        return; 
                    }
                    break; 

                case 'loan_approved': 
                    navigate('/congratulations');
                    return; 
                
                case 'loan_rejected': 
                    navigate('/no-approval');
                    return; 

                case 'payment_done': 
                    navigate('/payment-successful');    
                    break;
                case 'no-auth': 
                    navigate('/');
                    break;

                case "direct_payment": 
                    navigate('/no-approval', { state: { directPayment: true } });
                    break;

                default: 
                    navigate('/');
                    break; 
            }
        }
    }

    checkAccess();
  }, []);

  return (
    <Outlet context={data} />
  )
}

export default AccessManager
